'use strict';

var JSConstants = require('_core_ext/pages/tradecard/constants');
var CSSConstants = require('_core_ext/pages/tradecard/cssconstant');

function initRoleSelector () {
    $(document)
        .on('change keyup', JSConstants.ROLE_SELECTOR, function (e) {
            e.preventDefault();
            var $el = $(e.currentTarget),
                selectedValue = $el.val(),
                showCompanyNamesConf = ($el.data('showCompany') || '').toString().split(','),
                hideCompanyNameForRole = showCompanyNamesConf && showCompanyNamesConf.indexOf(selectedValue) > -1,
                ROLES = JSConstants.CONSTANTS.ROLES;

            $(JSConstants.ROLE_ADDITIONAL).addClass(CSSConstants.HIDDEN);

            switch (selectedValue) {
                case ROLES.SALON_OWNER:
                    $(JSConstants.ROLE_SALON_OWNER).removeClass(CSSConstants.HIDDEN);
                    break;
                case ROLES.MOBILE_HAIR:
                case ROLES.MOBILE_TECH:
                    $(JSConstants.ROLE_MOBILE_HAIRDRESSER).removeClass(CSSConstants.HIDDEN);
                    break;
                }

            if (hideCompanyNameForRole) {
                $(JSConstants.CLASS_HIDE_COMPANY_NAME).addClass(CSSConstants.HIDDEN);
            }
        });
}

module.exports = {
    init: function () {
        initRoleSelector();
    }
};